import { render } from "./RoundButton.vue?vue&type=template&id=5fd96fdb&scoped=true"
import script from "./RoundButton.vue?vue&type=script&lang=js"
export * from "./RoundButton.vue?vue&type=script&lang=js"

import "./RoundButton.vue?vue&type=style&index=0&id=5fd96fdb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd96fdb"]])

export default __exports__